import isEmpty from 'lodash.isempty'
import { bool, node, object } from 'prop-types'
import React, { useState, useEffect, Fragment } from 'react'
import { useFirstRender } from '../../hooks/useFirstRender'

const HiddenQuestion = ({
  children,
  state,
  question,
  values,
  isStrategyBuilderQuestion,
  ...props
}) => {
  const defaultState = !isEmpty(question.hideTrigger)
  const [isHidden, setIsHidden] = useState(false)
  const firstRender = useFirstRender()

  const getHideTriggerId = () => {
    if (question.hideTrigger) {
      return question.hideTrigger.split('-')[0]
    }
    return null
  }

  useEffect(() => {
    if (firstRender && !isStrategyBuilderQuestion) {
      setIsHidden(defaultState)
    } else {
      setIsHidden(state)
    }
  }, [state, values[getHideTriggerId()]])

  if (isHidden) return null
  return <Fragment {...props}>{children}</Fragment>
}

HiddenQuestion.propTypes = {
  children: node,
  state: bool,
  values: object,
  question: object,
  isStrategyBuilderQuestion: bool,
}

export default HiddenQuestion
